"use strict";
exports.__esModule = true;
exports.chart_color_orange_100 = {
  "name": "--pf-v5-chart-color-orange-100",
  "value": "#f4b678",
  "var": "var(--pf-v5-chart-color-orange-100, #f4b678)"
};
exports["default"] = exports.chart_color_orange_100;